module.exports = __webpack_public_path__ + "static/media/Logo_IDEA_20.46d90057.png";